import React, { useEffect, useState } from "react";
import LineGraph from "../Components/LineGraph";
import LinearGauge from "../Components/LinearGauge";
import FilterSelector from "../Components/FilterSelector";

function CashFlowMargin({ data, cushion }) {
  const [activeDuration, setActiveDuration] = useState("overall_summary");
  const [marginValue, setMarginValue] = useState(0);
  const [remark, setRemark] = useState("");
  const [graphData, setGraphData] = useState({
    xdata: [],
    ydata: [],
  });
  const getColor = (remark) => {
    switch (remark) {
      case "Critical":
      case "Low":
        return "#d30d00";
      case "Medium":
        return "#f7a452";
      case "High":
        return "#00960f";
      default:
        return "#f7a452";
    }
  };

  useEffect(() => {
    setMarginValue(
      data ? data[activeDuration]?.cashflow_margin.overall_cashflow_margin : 0
    );
    setRemark(
      data ? data[activeDuration]?.cashflow_margin.cashflow_margin_remark : ""
    );
    setGraphData({
      xdata: data
        ? data[activeDuration]?.cashflow_margin.cashflow_margin_trend["x-axis"]
        : [],
      ydata: data
        ? data[activeDuration]?.cashflow_margin.cashflow_margin_trend["y-axis"]
        : [],
    });
    // setGraphData(mapData(data[activeDuration]?.monthly_average_balance));
  }, [activeDuration, data]);
  return (
    <div className="  w-[49.5%] h-fit">
      <div className="  border border-[#e6ebed] rounded-lg pb-2">
        <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
          <p>Cash Flow Margin</p>
        </div>
        <FilterSelector
          activeDuration={activeDuration}
          setActiveDuration={setActiveDuration}
        />
        <div className=" mt-6 mb-6 flex flex-col items-center">
          <p className=" text-center text-[32px] font-bold">{marginValue}</p>
          <LinearGauge value={marginValue} color={getColor(remark)} />
          <p className=" text-xs font-medium text-[#262626] mt-4">
            Cash Flow Margin is{" "}
            <span className={` font-bold text-[${getColor(remark)}]`}>
              {remark}
            </span>{" "}
          </p>
        </div>
        <LineGraph
          title={"Cash Flow Margin History"}
          color={"#f7a452"}
          legendName={"Cash Flow Margin"}
          xdata={graphData.xdata}
          ydata={graphData.ydata}
        />
      </div>
      <div className=" w-full h-fit border border-[#e6ebed] rounded-lg pb-2 mt-4">
        <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
          <p>Financial Cushion</p>
        </div>
        <div className=" w-full flex flex-col mt-4 pb-1">
          <p className=" text-base font-bold mx-auto">{cushion || "--"}</p>
          <div className=" w-full pl-6 flex text-xs font-medium items-center mt-4 text-[#212b36]">
            <p>Financial Cushion = </p>
            <div className="ml-[2px] ">
              <p>Total Liquid Assets</p>
              <div className=" h-[1px] w-[130px] bg-[#000000]"></div>
              <p>Avg Monthly Expense</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CashFlowMargin;
